import React from 'react';
import config from './config';
import { RESULT_CODE, SYSTEM_ERROR_TYPE } from './const';
import { ERROR } from './message';
import { convertSize } from './util';
import {
  setSystemErrorType,
  setSystemProgressFLg,
  setProgressVal,
  setNetworkSpeed,
  setErrorMessage,
  setAuthErrorFlg,
  setMultiLoginFlg,
} from '../app/actions/CommonAction';

/**
 * APIのエンドポイント
 * @type     {object} エンドポイント定義
 * @property {string} AUTH_USER                         ユーザー認証
 * @property {string} GET_USER                          ユーザー情報取得
 * @property {string} GET_CONTRACT_LABEL                契約ラベル取得
 * @property {string} GET_TOKEN                         CSRFトークン取得
 * @property {string} LOGOUT                            ログアウト
 * @property {string} GET_FILE                          ファイル取得
 * @property {string} DOWNLOAD_COMPANY_OFFICE_FILE_DUNS 企業・事業所情報ファイルダウンロード
 * @property {string} GET_AREA                          地域マスタ取得
 * @property {string} GET_ADDRESS                       住所マスタ取得
 * @property {string} GET_INDUSTRY                      業種マスタ取得
 * @property {string} SEARCH_INDUSTRY                   業種キーワード検索
 * @property {string} SEARCH_COMPANY_LIST_SINGLE        企業情報一覧検索（単一条件）
 * @property {string} GET_COMPANY_HIERARCHY             企業階層情報取得
 * @property {string} GET_OFFICE_LIST                   事業所情報一覧取得
 * @property {string} GET_OFFICE_DETAIL                 事業所情報詳細取得
 * @property {string} CREATE_COMPANY_OFFICE_FILE_CODE   企業・事業所情報ファイル作成リクエスト（企業コード）
 * @property {string} GET_AREA_HIERARCHY                地域階層情報取得
 * @property {string} GET_COMPANY_SEARCHLIST            企業情報一覧検索（複数条件）
 * @property {string} CREATE_COMPANY_OFFICE_FILE_MULTI  企業・事業所情報ファイル作成リクエスト（複数条件）
 * @property {string} UPLOAD_COMPANY_UPDATE             データ更新ファイルアップロード
 * @property {string} UPLOAD_COMPANY_UPDATE_JOBLIST     データ更新ジョブ一覧取得
 * @property {string} MATCHING_COMPANY_MATCHING_JOBLIST マッチングジョブ一覧取得
 * @property {string} MATCHING_COMPANY_MATCHING_HISTORY マッチングジョブ履歴取得
 * @property {string} MATCHING_COMPANY_UPLOAD           マッチングファイルアップロード
 * @property {string} MATCHING_COMPANY_MATCHING_CREATE  マッチングジョブファイル作成
 * @property {string} MATCHING_COMPANY_DONWLOAD         マッチング結果ダウンロード
 * @property {string} LOG_OUTPUT_CHART_DATA             アクセスログ取得
 * @property {string} LOG_OUTPUT_DONWLOAD               アクセスログダウンロード
 * @property {string} GET_USER_INFO                     ユーザー情報検索
 * @property {string} UPDATE_USER_INFO                  ユーザー情報更新
 * @property {string} RESET_PASSWORD                    パスワード初期化
 * @property {string} DOWNLOAD_ALL_USER                 全ユーザー取得
 * @property {string} GET_ROLE                          権限マスタ取得
 * @property {string} UPDATE_PASSWORD                   パスワード更新
 * @property {string} CHECK_PASSWORD_EXPIRATION_DATE    パスワード有効期限確認
 * @property {string} GET_ADDITIONAL                    お客様取引情報項目マスタ取得
 * @property {string} GET_EXTERNALDATA_HISTORY          外部データ取込履歴検索
 * @property {string} DOWNLOAD_EXTERNALDATA_HISTORY     外部データ取込履歴ファイルダウンロード
 * @property {string} GET_DISP_ITEM                     表示項目取得
 * @property {string} SEARCH_ATSUKAIHIN                 扱い品キーワード検索
 * @property {string} UPDATE_EXCLUDE_FLG                非同期ステータス除外フラグ更新
 * @property {string} GET_MAPPING                       Salesforce連携マッピング取得
 * @property {string} GET_EXTERNAL_INFO                 外部連携情報取得
 * @property {string} CREATE_COMPANY_OFFICE_FILE_EXTERNAL ターゲティング外部連携ファイル作成
 */
export const API_END_POINT = {
  AUTH_USER: 'authenticate/user',
  GET_USER: 'get/user',
  GET_CONTRACT_LABEL: 'get/contract-label',
  GET_TOKEN: 'get/token',
  LOGOUT: 'logout',
  GET_FILE: 'get/file',
  DOWNLOAD_COMPANY_OFFICE_FILE_DUNS: 'download/company-office/file/duns',
  GET_AREA: 'get/area',
  GET_ADDRESS: 'get/address',
  GET_INDUSTRY: 'get/industry',
  SEARCH_INDUSTRY: 'search/industry',
  SEARCH_COMPANY_LIST_SINGLE: 'search/company/list/single',
  GET_COMPANY_HIERARCHY: 'get/company/hierarchy',
  GET_OFFICE_LIST: 'get/office/list',
  GET_OFFICE_DETAIL: 'get/office/detail',
  GET_ADDITIONAL_ITEM_LIST: 'get/additional-item/list',
  CREATE_COMPANY_OFFICE_FILE_CODE: 'create/company-office/file/code',
  GET_AREA_HIERARCHY: 'get/area/hierarchy',
  GET_COMPANY_SEARCHLIST: 'search/company/list/multi',
  CREATE_COMPANY_OFFICE_FILE_MULTI: 'create/company-office/file/multi',
  UPLOAD_COMPANY_UPDATE: 'upload/company-update',
  UPLOAD_COMPANY_UPDATE_JOBLIST: 'upload/company-update/joblist',
  MATCHING_COMPANY_MATCHING_JOBLIST: 'matching/company-matching/joblist',
  MATCHING_COMPANY_MATCHING_HISTORY: 'matching/company-matching/history',
  MATCHING_COMPANY_UPLOAD: 'upload/matching-company',
  MATCHING_COMPANY_CREATE: 'matching/create',
  MATCHING_COMPANY_DONWLOAD: 'matching/download',
  LOG_OUTPUT_CHART_DATA: 'get/usage-log',
  LOG_OUTPUT_DONWLOAD: 'download/usage-log',
  GET_USER_INFO: 'manage/user/search-user',
  UPDATE_USER_INFO: 'manage/user/update-user',
  RESET_PASSWORD: 'manage/user/reset',
  DOWNLOAD_ALL_USER: 'manage/user/download/all-user',
  GET_ROLE: 'get/role',
  UPDATE_PASSWORD: 'update/authenticate/user-pw',
  CHECK_PASSWORD_EXPIRATION_DATE: 'check/authenticate/expiration-date',
  GET_ADDITIONAL: 'get/additional',
  GET_EXTERNALDATA_HISTORY: 'common/search-history',
  GET_EXTERNALDATA_SEND_HISTORY: 'external/search-history',
  DOWNLOAD_EXTERNALDATA_HISTORY: 'common/download/history',
  DOWNLOAD_EXTERNALDATA_SEND_HISTORY: 'external/download/history',
  GET_IMPORT_BUSINESSCARD_STATUS: 'businesscard/import',
  GET_DISP_ITEM: 'get/dispItems',
  GET_GYOTAI_LIST: 'get/code',
  SEARCH_ATSUKAIHIN: 'search/atsukaihin',
  CREATE_SEARCH_CONDITION: 'create/targeting-criteria',
  GET_SEARCH_CONDITION_LIST: 'get/targeting-criteria/list',
  GET_SEARCH_CONDITION: 'get/targeting-criteria',
  IMPORT_SEARCH_CONDITION: 'import/targeting-criteria',
  DELETE_SEARCH_CONDITION: 'delete/targeting-criteria',
  GET_ADDRESS_MULTI: 'get/address/multi',
  GET_INDUSTRY_MULTI: 'get/industry/multi',
  GET_ATSUKAIHIN_MULTI: 'get/atsukaihin/multi',
  SEARCH_COMPANY: 'search/company',
  GET_TARGETING_DISP_ITEMS: 'get/targetingDispItems',
  SEARCH_ADDRESS: 'search/address',
  UPDATE_EXCLUDE_FLG: 'batch/async/status/update-exclude-flg',
  GET_MAPPING: 'get/mapping',
  GET_EXTERNAL_INFO: 'get/externalInfo',
  CREATE_COMPANY_OFFICE_FILE_EXTERNAL: 'create/company-office/file/external',
};

/**
 * メッセージ返却対象外APIのエンドポイント
 */
export const EXCLUSION_MSG_API = [
  API_END_POINT.SEARCH_COMPANY_LIST_SINGLE,
  API_END_POINT.GET_COMPANY_SEARCHLIST,
  API_END_POINT.CREATE_COMPANY_OFFICE_FILE_CODE,
  API_END_POINT.CREATE_COMPANY_OFFICE_FILE_MULTI,
  API_END_POINT.GET_AREA,
  API_END_POINT.GET_ADDRESS,
  API_END_POINT.GET_INDUSTRY,
  API_END_POINT.GET_OFFICE_DETAIL,
  API_END_POINT.SEARCH_ATSUKAIHIN,
];

/**
 * CSRFトークンのCookieキー
 * @type     {string} Cookieキー
 */
export const CSRF_TOKEN_NAME = 'XSRF-TOKEN';

/**
 * APIのURLを取得
 * @param   {string} endPoint エンドポイント
 * @returns {string} URL文字列
 */
const getUrlOfApi = (endPoint) => `${config.API_PROTOCOL}://${config.API_HOST}:${config.API_PORT}/${config.API_NAME}/${endPoint}`;

/**
 * Cookieの値をkeyから取得
 * @param  {string} key key
 * @return {string} 値
 */
// 対象のCookieの値が存在しない場合、空配列の2番目の値を取得しに行くため、要素数2の空配列を定義している
const getCookieValue = (key) => ((`${document.cookie};`).match(`${key}=([^¥S;]*)`) || ['', ''])[1];

/**
 * APIのリクエストオブジェクトを取得
 * @param  {object}  body     リクエストボディ
 * @param  {boolean} isUpload アップロードフラグ
 * @return {object}  リクエストオブジェクト
 */
const getRequestOfApi = (body, isUpload) => {
  const token = getCookieValue(CSRF_TOKEN_NAME);
  const h = isUpload
    ? { 'X-XSRF-TOKEN': token }
    : {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': token,
    };
  const b = isUpload ? body : JSON.stringify(body);
  return {
    method: 'POST',
    headers: h,
    mode: 'cors',
    credentials: 'include',
    body: b,
  };
};

/**
 * ダウンロードダイアログ表示処理
 * @param {Dispatch} dispatch actionを呼ぶための関数
 * @param {object} res レスポンス
 * @returns {string} ファイルテキスト
 */
const dispDownloadDialog = async (dispatch, res) => {
  // コンテンツの長さ（ファイル容量）を取得
  const total = res.headers.get('content-length');
  const reader = res.body.getReader();
  // 進捗率、速度の初期化
  dispatch(setProgressVal(0));
  dispatch(setNetworkSpeed('0'));
  // 進捗ダイアログを表示
  dispatch(setSystemProgressFLg(true));
  const stream = new ReadableStream({
    start(controller) {
      let chunk = 0;
      let bChunk = 0;
      // 現在時間を取得
      let bTime = Date.now();
      const processResult = () => reader.read().then(({ done, value }) => {
        if (done) {
          // レスポンスが全て返ってきたらループ終了
          controller.close();
          // 進捗ダイアログを非表示
          dispatch(setSystemProgressFLg(false));
          return;
        }
        // 現時点でダウンロード済みのファイル容量を取得
        chunk += value.length;
        // 現在時間を取得
        const aTime = Date.now();
        // 進捗率の算出（ダウンロード済みファイル容量/全ファイル容量*100 少数点切り捨て）
        const percent = ((chunk / total) * 100).toFixed(0);
        // 進捗率の設定
        dispatch(setProgressVal(percent));
        // 速度は100ミリ秒毎に計測するよう調整
        if ((aTime - bTime) > 100 || bChunk === 0) {
          // 速度の算出（ファイル容量、時間の前後差分を算出後、除算を行う ※秒単位の速度を表示するため1000倍）
          const speed = ((chunk - bChunk) / (aTime - bTime)) * 1000;
          // 現在時間の置き換え
          bTime = aTime;
          // ファイル容量の置き換え
          bChunk = chunk;
          // 速度の設定
          dispatch(setNetworkSpeed(convertSize(speed)));
        }
        controller.enqueue(value);
        processResult();
      }).catch(() => {
        controller.error();
      });
      return processResult();
    },
  });
  return new Response(stream);
};

/**
 * フロントエンドAPI呼び出し共通関数
 * @param   {Dispatch} dispatch   actionを呼ぶための関数
 * @param   {string}   endPoint   エンドポイント
 * @param   {string}   params     パラメータ
 * @param   {boolean}  isUpload   アップロードフラグ
 * @param   {boolean}  isDownload ダウンロードフラグ
 * @returns {object}   レスポンスオブジェクト
 */
export const requestApi = async (dispatch, endPoint, params, isUpload = false,
  isDownload = false) => {
  const ret = {
    result: RESULT_CODE.SUCCESS,
    response: null,
  };
  await fetch(getUrlOfApi(endPoint), getRequestOfApi(params, isUpload))
    .then(async (res) => {
      if (res.ok) {
        if (isDownload) {
          const stream = await dispDownloadDialog(dispatch, res);
          ret.response = await stream.blob().catch(() => { throw Error(); });
        } else {
          ret.response = await res.json().catch(() => null);
        }
      } else {
        switch (res.status) {
          case 401:
            dispatch(setSystemErrorType(SYSTEM_ERROR_TYPE.AUTH_NG));
            break;
          case 403:
            dispatch(setSystemErrorType(SYSTEM_ERROR_TYPE.CSRF_NONE));
            break;
          case 503:
            dispatch(setSystemErrorType(SYSTEM_ERROR_TYPE.CLOSE));
            break;
          default:
            break;
        }
        const data = await res.json().catch(() => null);
        ret.result = res.status === 413 ? RESULT_CODE.WARN : RESULT_CODE.ERROR;
        // ステータスが404かつエラーメッセージ返却対象外APIリストに含まれるエンドポイントかつmessageが空の場合、取得件数0件とする
        if (res.status === 404) {
          ret.result = EXCLUSION_MSG_API.includes(endPoint)
          && data
          && !data.message
            ? RESULT_CODE.NOT_FOUND
            : RESULT_CODE.ERROR;
        }
        if (data && data.error_list) {
          // エラーメッセージ作成
          const msgs = [];
          data.error_list.forEach((message, index) => {
            msgs.push(<div key={'error-'.concat(index)}>{message}</div>);
          });
          ret.response = msgs;
        }
        // 認証エラーフラグ表示判定
        if (res.status === 401
          && endPoint !== API_END_POINT.GET_TOKEN
          && endPoint !== API_END_POINT.GET_USER) {
          dispatch(setAuthErrorFlg(true));
        }
        // 多重ログインエラーメッセージ表示判定
        if (data && data.path === '/tjs-ex/bff/expire') {
          dispatch(setMultiLoginFlg(true));
        }
      }
    })
    .catch(() => {
      ret.result = RESULT_CODE.ANOMALY;
      ret.response = [<div key="error-1">{ERROR.E09013}</div>];
      if (isDownload) dispatch(setSystemProgressFLg(false));
    });
  return ret;
};

/**
 * フロントエンドAPI呼び出し共通関数（アップロード）
 * @param   {Dispatch} dispatch   actionを呼ぶための関数
 * @param   {string}   endPoint   エンドポイント
 * @returns {XMLHttpRequest}      XMLHttpRequestオブジェクト
 */
export const requestFileApi = async (dispatch, endPoint) => {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', getUrlOfApi(endPoint), true);
  xhr.withCredentials = true;
  const token = getCookieValue(CSRF_TOKEN_NAME);
  xhr.setRequestHeader('X-XSRF-TOKEN', token);
  // イベント開始時処理
  xhr.onloadstart = () => {
    // 進捗率、速度の初期化
    dispatch(setProgressVal(0));
    dispatch(setNetworkSpeed('0'));
    // 進捗ダイアログを表示
    dispatch(setSystemProgressFLg(true));
  };
  // イベント終了時処理
  xhr.onloadend = () => {
    // 進捗ダイアログを非表示
    dispatch(setSystemProgressFLg(false));
  };
  let bLoaded = 0;
  // 現在時間を取得
  let bTime = Date.now();
  // アップロード進捗イベント
  xhr.upload.onprogress = (evt) => {
    // 現時点でアップロード済みのファイル容量を取得
    const aLoaded = evt.loaded;
    // 現在時間を取得
    const aTime = Date.now();
    // 進捗率の算出（アップロード済みファイル容量/全ファイル容量*100 少数点切り捨て）
    const percent = ((aLoaded / evt.total) * 100).toFixed(0);
    // 進捗率の設定
    dispatch(setProgressVal(percent));
    // 速度は100ミリ秒毎に計測するよう調整
    if ((aTime - bTime) > 100 || bLoaded === 0) {
      // 速度の算出（ファイル容量、時間の前後差分を算出後、除算を行う ※秒単位の速度を表示するため1000倍）
      const speed = ((aLoaded - bLoaded) / (aTime - bTime)) * 1000;
      // 現在時間の置き換え
      bTime = aTime;
      // ファイル容量の置き換え
      bLoaded = aLoaded;
      // 速度の設定
      dispatch(setNetworkSpeed(convertSize(speed)));
    }
  };
  // レスポンス受信後処理
  xhr.onload = () => {
    if (xhr.status === 200) xhr.oncsuccess();
    else xhr.oncerror();
  };
  // レスポンスがエラーの場合の処理
  xhr.oncerror = () => {
    switch (xhr.status) {
      case 401:
        dispatch(setSystemErrorType(SYSTEM_ERROR_TYPE.AUTH_NG));
        break;
      case 403:
        dispatch(setSystemErrorType(SYSTEM_ERROR_TYPE.CSRF_NONE));
        break;
      case 503:
        dispatch(setSystemErrorType(SYSTEM_ERROR_TYPE.CLOSE));
        break;
      default:
        break;
    }
    const data = JSON.parse(xhr.responseText);
    if (data && data.error_list) {
      // エラーメッセージ作成、表示
      const msgs = [];
      data.error_list.forEach((message, index) => {
        msgs.push(<div key={'error-'.concat(index)}>{message}</div>);
      });
      // エラーメッセージの設定
      dispatch(setErrorMessage(msgs));
    }
  };
  // 例外発生時の処理
  xhr.onerror = () => {
    // エラーメッセージの設定
    dispatch(setErrorMessage([<div key="error-1">{ERROR.E09013}</div>]));
    // 進捗ダイアログを非表示
    dispatch(setSystemProgressFLg(false));
  };
  return xhr;
};
